<c3-config-section-box
  [title]="TP_SECTIONS_INFO['education-ondemand'].label"
  [icon]="TP_SECTIONS_INFO['education-ondemand'].icon"
>
  <p config-description>
    {{ TP_SECTIONS_INFO["education-ondemand"].description }}
  </p>

  <div [c3ConfigForm]="this">
    <!-- empty msg -->
    <ng-container
      *ngIf="
        (availableOnDemandDialogs$ | async | dictFilterByTags: [currentContext$ | async])
          ?.length === 0
      "
    >
      <div class="c3-flex ion-align-items-center">
        <ion-icon
          size="small"
          color="tertiary"
          [src]="'information-outline' | getIcon"
          class="ion-margin-end"
        >
        </ion-icon>
        <span>Non sono presenti moduli on-demand attivabili</span>
      </div>
    </ng-container>

    <ion-list>
      <ion-item
        *ngFor="
          let module of availableOnDemandDialogs$
            | async
            | dictFilterByTags: [currentContext$ | async]
        "
        lines="none"
      >
        <ion-checkbox
          slot="start"
          [checked]="selection[module?.id]"
          [value]="module?.id"
          color="secondary"
          (ionChange)="onSelectionChange($event)"
        >
        </ion-checkbox>
        <ion-label>{{ module?.it }}</ion-label>
      </ion-item>
    </ion-list>
  </div>
</c3-config-section-box>
